import { AuthRole, PermissionArea } from "api/common/types/auth.types";
import { AppPermission } from "app/role.types";
import { checkPermissions } from "utils/permissions";

/**
 * Determines whether the current user can access a sidebar item
 * based on its allowed roles and required permission area.
 */
export const canAccessItem = (
  permissions: AppPermission,
  allowedRoles?: AuthRole[],
  requiredArea?: PermissionArea,
): boolean => {
  const roleType = permissions.role_type;
  const roleAllowed = !allowedRoles || allowedRoles.includes(roleType);

  const areaAllowed =
    !requiredArea || checkPermissions({ permissions, area: requiredArea });
  return roleAllowed && areaAllowed;
};
